import { Button } from "@designs-by-maryam/ui/components/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@designs-by-maryam/ui/components/dropdown-menu";
import { Skeleton } from "@designs-by-maryam/ui/components/skeleton";
import { Link, useNavigate } from "@tanstack/react-router";
import { LayoutDashboard } from "lucide-react";
import { authClient } from "@/lib/auth-client";
import { getDashboardUrl } from "@/lib/navigation";

export default function UserMenu() {
	const navigate = useNavigate();
	const { data: session, isPending, error } = authClient.useSession();

	if (isPending) {
		return <Skeleton className="h-9 w-24" />;
	}

	if (error || !session) {
		return (
			<Button asChild variant="outline">
				<Link to="/login">Sign In</Link>
			</Button>
		);
	}

	const dashboardUrl = getDashboardUrl(session.user.role);

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="outline">{session.user.name}</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="bg-card">
				<DropdownMenuLabel>My Account</DropdownMenuLabel>
				<DropdownMenuSeparator />
				<DropdownMenuItem>{session.user.email}</DropdownMenuItem>
				<DropdownMenuItem asChild>
					<Link
						className="flex cursor-pointer items-center gap-2"
						to={dashboardUrl}
					>
						<LayoutDashboard className="h-4 w-4" />
						Dashboard
					</Link>
				</DropdownMenuItem>
				<DropdownMenuSeparator />
				<DropdownMenuItem asChild>
					<Button
						className="w-full"
						onClick={() => {
							authClient.signOut({
								fetchOptions: {
									onSuccess: () => {
										navigate({
											to: "/",
										});
									},
								},
							});
						}}
						variant="destructive"
					>
						Sign Out
					</Button>
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
